import React, { useState } from "react";
import axios from "axios";
import LandingFooter from "../components/LandingFooter";
import { API } from "../utils/constants";

const Unsubscribe = () => {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [state, setState] = useState("confirm");

  const confirm = async () => {
    setState("sending");
    try {
      await axios.post(`${API}/email/unsubscribe`, { token });
      // The API deliberately gives a generic result. The warm confirmation is
      // therefore the same regardless of a stale or malformed mail link.
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#EEE7D8", color: "#51120A" }}>
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <section className="w-full max-w-xl text-center rounded-2xl px-7 py-12 md:px-14" style={{ background: "#F3EEE4" }}>
          <img src="/email/wellby-logo-brown.png" alt="Wellby" className="mx-auto mb-8" width="90" height="56" />
          {state === "done" ? (
            <>
              <h1 className="text-4xl mb-4" style={{ fontFamily: "'Instrument Serif', serif" }}>You&rsquo;re all set</h1>
              <p style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}>You won&rsquo;t receive future Wellby lifecycle emails.</p>
            </>
          ) : (
            <>
              <h1 className="text-4xl mb-4" style={{ fontFamily: "'Instrument Serif', serif" }}>Unsubscribe from Wellby emails?</h1>
              <p className="mb-8" style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}>We&rsquo;ll stop sending future welcome and invitation reminders.</p>
              {state === "error" && <p role="alert" className="mb-4">We couldn&rsquo;t update your preferences. Please try again.</p>}
              <button type="button" onClick={confirm} disabled={state === "sending"}
                className="rounded-lg px-6 py-3 text-white disabled:opacity-60"
                style={{ background: "#51120A", fontFamily: "'Bricolage Grotesque', sans-serif" }}>
                {state === "sending" ? "Updating…" : "Yes, unsubscribe me"}
              </button>
            </>
          )}
        </section>
      </main>
      <LandingFooter />
    </div>
  );
};

export default Unsubscribe;